import { render, staticRenderFns } from "./DeliveryNoteNew.vue?vue&type=template&id=5d461efc&scoped=true"
import script from "./DeliveryNoteNew.vue?vue&type=script&lang=js"
export * from "./DeliveryNoteNew.vue?vue&type=script&lang=js"
import style0 from "./DeliveryNoteNew.vue?vue&type=style&index=0&id=5d461efc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d461efc",
  null
  
)

export default component.exports